function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffline = function SvgOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 42,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21,
    r: 20,
    stroke: props.fill,
    strokeDasharray: "4 8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10.834 11.833 18.333 18.333M23.933 20.217c.683.333 1.321.75 1.9 1.242M14.167 21.459a9.1 9.1 0 0 1 4.308-1.992M18.925 15.208a13.34 13.34 0 0 1 9.892 3.292M11.183 18.5a13.3 13.3 0 0 1 3.917-2.4M17.108 24.425a5 5 0 0 1 5.792 0M20 27.667h.008"
  }));
};
export default SvgOffline;